import { MessageBus } from '@23degrees/shared/bus';
import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { REQUEST_MESSAGES, RESPONSE_MESSAGES } from '@config';

import { ContentTypeDescriptors } from '@23degrees/shared-code/config/constants';
import { Content } from '@23degrees/shared-code/models';
import { BaseClass } from '@23degrees/shared/classes/base.class';
import { ImageFallbackDirective } from '@23degrees/shared/directives';
import { LoadingIndicatorComponent } from '@23degrees/ui/atoms/loading-indicator/loading-indicator.component';
import { Router } from '@angular/router';

@Component({
    selector: 'smart-ssr',
    templateUrl: './smart-ssr.component.html',
    styleUrls: ['./smart-ssr.component.scss'],
    imports: [ImageFallbackDirective, LoadingIndicatorComponent]
})
export class SmartSSRComponent extends BaseClass {
  private messageBus = inject(MessageBus);
  private router = inject(Router);
  private cdr = inject(ChangeDetectorRef);

  @Input() slug: string;
  @Input() referenceID: string;
  public content: Content;
  public url: string;

  public isEmbed: boolean = true;
  public showReload: boolean = true;
  public icon: string;

  constructor() {
    super();

    this.url = this.router.url;

    this.showReload = this.isEmbed = this.url.includes('/embed');
  }

  ngOnInit(): void {
    this.messageBus.on(RESPONSE_MESSAGES.ContentBySlug, 'SSR', this.receiveContent, this.componentDestroyed$, this.referenceID);
    this.messageBus.emit(REQUEST_MESSAGES.ContentBySlug, ['SSR'], { slug: this.slug, public: true }, this.referenceID);
  }

  private receiveContent = (msg) => {
    const { content } = msg;
    this.content = content;
    this.icon = ContentTypeDescriptors.find((type) => type.value === this.content.type)?.icon;
    this.cdr.detectChanges();
  };
}
